import { api } from "../api";

export class HomeService {

    async test () {
        return await api.get(`/home`)
        .then((result) => {
            if (result?.status === 200) {
              return true
            } else {
              return false
            }
          });
          
    }
    
}